// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"e0604c12","240":"a44b67b0","429":"557c4138","809":"e6842a0d"}[chunkId] + ".chunk.js";
};